import React from "react";

function Privacy() {
    const isWebSetting = localStorage.getItem("isWebSetting");
    const parseWebSetting = JSON.parse(isWebSetting);


    return (
        <div className="flex flex-col gap-3 flex-1 relative ">
            <div className="flex flex-col lg:rounded-lg rounded-none shadow-inner bg-cardLight dark:bg-cardDark sm: min-h-[450px] p-3">
            <span className=" text-2xl font-bold text-center my-3">Privacy</span>
                <div
                    dangerouslySetInnerHTML={{ __html: parseWebSetting?.privacy }}
                    className={` text-base`}
                />
            </div>
        </div>
    );
}

export default Privacy;
